import {
  HotelItem,
  SearchHotelParam,
  SearchHotelResponse,
  SearchListHotelParams,
} from "@/types";
import axiosInstance from "./api";

export function findHotelService(
  params: SearchHotelParam,
): Promise<SearchHotelResponse> {
  return axiosInstance
    .post("/hotel/find", params)
    .then((response) => response.data);
}

export function findHotelByName(keyword: string): Promise<HotelItem[]> {
  return axiosInstance
    .get("/hotel/search-by-name", { params: { keyword } })
    .then((response) => response.data);
}

export function hotelSearch(
  params: SearchListHotelParams,
): Promise<SearchHotelResponse> {
  return axiosInstance
    .get("/hotel-search/search", { params })
    .then((response) => ({
      ...response.data,
      data: response.data?.data?.map(
        (item: { hotelId: string; hotelName: string }) => ({
          hotelId: `${item.hotelId}`,
          hotelName: item.hotelName,
        }),
      ),
    }));
}

export function fetchFeaturedHotel(ids: string[]): Promise<HotelItem[]> {
  // const params = ids
  //   .map((id, index) => (index + 1 === ids.length ? id : `${id}&`))
  //   .join("ids=");

  return axiosInstance
    .get(`/hotel/featured-hotels`, { params: { ids } })
    .then((response) => response.data);
}
